export default __webpack_public_path__ + "static/media/cta.9ccfbd22.png";